import React from 'react'

import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import PropTypes from 'prop-types'

import { createInteliblyTheme } from './createTheme'
import { injectInteliblyCSS } from './injectVariables'

export const ThemeProvider = ({ children, theme, ...props }) => {
  const finalTheme = theme || createInteliblyTheme()

  React.useEffect(() => {
    injectInteliblyCSS()
  }, [])

  return (
    <MuiThemeProvider theme={finalTheme} {...props}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  )
}

ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.object,
}
